import { apiGet, apiPut } from '../lib/api'

export const NOTIFICATIONS_LOAD_START = 'NOTIFICATIONS_LOAD_START'
export const NOTIFICATIONS_LOAD_SUCCESS = 'NOTIFICATIONS_LOAD_SUCCESS'
export const NOTIFICATIONS_LOAD_ERROR = 'NOTIFICATIONS_LOAD_ERROR'

export const NOTIFICATION_UPDATE_START = 'NOTIFICATION_UPDATE_START'
export const NOTIFICATION_UPDATE_SUCCESS = 'NOTIFICATION_UPDATE_SUCCESS'
export const NOTIFICATION_UPDATE_ERROR = 'NOTIFICATION_UPDATE_ERROR'

export const NOTIFICATIONS_UPDATE_START = 'NOTIFICATIONS_UPDATE_START'
export const NOTIFICATIONS_UPDATE_SUCCESS = 'NOTIFICATIONS_UPDATE_SUCCESS'
export const NOTIFICATIONS_UPDATE_ERROR = 'NOTIFICATIONS_UPDATE_ERROR'

export const loadNotifications = () => ({ getState, fetch }) => ({
  type: 'NOTIFICATIONS_LOAD',
  payload: apiGet({
    fetch,
    endpoint: 'notification',
    getState,
  }),
})

export const updateNotification = (id) => ({ getState, fetch }) => ({
  type: 'NOTIFICATION_UPDATE',
  payload: apiPut({
    fetch,
    endpoint: `notification/${id}`,
    getState,
  }),
})

export const updateNotifications = () => ({ getState, fetch }) => ({
  type: 'NOTIFICATIONS_UPDATE',
  payload: apiPut({
    fetch,
    endpoint: 'notification',
    getState,
  }),
})



// WEBPACK FOOTER //
// ./src/common/notifications/actions.js